import { gql } from "@apollo/client";

export const APPLY_DISCOUNT_MUTATION = gql`
  mutation applyDiscount($bookingId: ID!, $discount: DiscountCreateInput!) {
    applyDiscount(bookingId: $bookingId, discount: $discount) {
      id
      dateStarted
      pcoNumber
      dateReturned
      organisationId
      quoteUrl
      rentalAgreementUrl
      vehicleConditionReportUrls
      quoteUrl
      protectionPlan{
        plan {
          id
          name
          description
          excess
          code
        }
        name
        tax {
          title
          value
        }
        hasFixedRate
        rate
        taxable
        payableAmount
        taxAmount
      }
      bookingConfirmationUrl
      poNumber
      zeroCostBooking
      zeroCostBookingNote
      invoiceNote
      isSubscription
      activeSubscription {
        startDate
        endDate
        subscription {
          id
          name
          rateTypeName
          insurancePolicy {
            name
          }
          addons {
            displayName
          }
        }
        vehicle {
          licencePlate
          make
          model
          vin
          id
        }
        duration
        subscriptionAmount
        enrollmentAmount
        mileageLimit
        unlimitedMileage
        pricePerExtraMile
        swapsAllowed
      }
      depositDetails {
        amount
        amountAdjusted
        payment {
          id
          status
        }
        adjustedAgainst {
          id
          invoiceRef
        }
        refund {
          amount
          refundRef
          status
          mode
          currency
          id
          paymentIntent
          paymentId
        }
      }
      creditNotes {
        id
        creditNoteRef
        createdAt
        invoice {
          invoiceRef
        }
        totalAmount
        refundedAmount
        availableAmount
        creditNoteItems {
          type
          description
          originalPrice
          quantity
          unitPrice
          totalAmount
          duration
        }
        refunds {
          mode
          amount
          status
          id
          refundRef
          currency
          paymentIntent
        }
        allocations {
          amount
          allocatedAt
          invoice {
            invoiceRef
          }
        }
      }
      latestExtension {
        extensionNumber
        referenceNumber
        startDate
        endDate
        status
        id
      }
      extensions {
        extensionNumber
        referenceNumber
        startDate
        endDate
        status
        id
        invoice {
          invoiceRef
        }
        dropoffServiceLocation {
          name
        }
      }
      firstInvoice {
        dateCreated
        dateUpdated
        createdBy
        updatedBy
        discount {
          appliedBy
          appliedDate
          isPercent
          code
          amount
        }
        invoiceRef
        status
        locked
        invoiceType
        startDate
        endDate
        tax {
          appliedBy
          appliedDate
          code
          amount
        }
        invoiceItems {
          type
          description
          quantity
          unitPrice
          totalAmount
        }
        totalPayableAmount
        anyPaidAmount
        confirmedPaidAmount
        anyRefundAmount
        confirmedRefundAmount
        otherRefunds
        depositRefund
        balanceDueFromPreviousInvoice
        damageAmount
        finesAmount
        valetAmount
        otherCharges {
          amount
          name
        }
        id
        taxAmount
        rentalAmount
        insuranceAmount
        discountAmount
        addonsAmount
        rateTypeName
        rateTypeDuration
        payments {
          id
          dateCreated
          lastUpdated
          createdBy
          updatedBy
          note
          paymentMode
          paymentType
          emailNotify
          expireBy
          amount
          currency
          description
          smsNotify
          status
        }
      }
      currentInvoice {
        dateCreated
        dateUpdated
        createdBy
        updatedBy
        discount {
          appliedBy
          appliedDate
          isPercent
          code
          amount
        }
        invoiceRef
        status
        locked
        invoiceType
        startDate
        endDate
        tax {
          appliedBy
          appliedDate
          code
          amount
        }
        invoiceItems {
          type
          description
          quantity
          unitPrice
          totalAmount
        }
        totalPayableAmount
        anyPaidAmount
        confirmedPaidAmount
        anyRefundAmount
        confirmedRefundAmount
        otherRefunds
        depositRefund
        balanceDueFromPreviousInvoice
        damageAmount
        finesAmount
        valetAmount
        otherCharges {
          amount
          name
        }
        id
        taxAmount
        rentalAmount
        insuranceAmount
        discountAmount
        addonsAmount
        rateTypeName
        rateTypeDuration
        payments {
          id
          dateCreated
          lastUpdated
          createdBy
          updatedBy
          note
          paymentMode
          paymentType
          emailNotify
          expireBy
          amount
          currency
          description
          smsNotify
          status
        }
      }
      finalInvoice {
        dateCreated
        dateUpdated
        createdBy
        updatedBy
        discount {
          appliedBy
          appliedDate
          isPercent
          code
          amount
        }
        invoiceRef
        status
        locked
        invoiceType
        startDate
        endDate
        tax {
          appliedBy
          appliedDate
          code
          amount
        }
        invoiceItems {
          type
          description
          quantity
          unitPrice
          totalAmount
        }
        totalPayableAmount
        anyPaidAmount
        confirmedPaidAmount
        anyRefundAmount
        confirmedRefundAmount
        otherRefunds
        depositRefund
        balanceDueFromPreviousInvoice
        damageAmount
        finesAmount
        valetAmount
        otherCharges {
          amount
          name
        }
        id
        payments {
          id
          dateCreated
          lastUpdated
          createdBy
          updatedBy
          note
          paymentMode
          paymentType
          emailNotify
          expireBy
          amount
          currency
          description
          smsNotify
          status
        }
      }
      referenceNumber
      dateCreated
      dateUpdated
      createdBy {
        id
        firstName
        lastName
      }
      updatedBy {
        id
        firstName
        lastName
      }
      pickupServiceLocation {
        id
        name
        address {
          street
          city
          state
          country
          zipcode
          fullAddress
        }
      }
      pickupOtherLocation {
        street
        city
        state
        country
        zipcode
        fullAddress
        location {
          type
          latitude
          longitude
        }
      }
      pickupDateTime
      dropoffServiceLocation {
        id
        name
        address {
          street
          city
          state
          country
          zipcode
          fullAddress
        }
      }
      dropoffOtherLocation {
        street
        city
        state
        country
        zipcode
        fullAddress
        location {
          type
          latitude
          longitude
        }
      }
      dropoffDateTime
      initialDropoffDateTime
      longTermBooking
      flightNumber
      insuranceRate
      excess
      customerType
      discount {
        appliedBy
        appliedDate
        isPercent
        code
        amount
      }
      tax {
        appliedBy
        appliedDate
        code
        amount
        payableAmount
        type
        rate
        isVehicleGroupSpecific
        vehicleGroups
        subdivisionOptIn
        subdivisionValue
        subdivisionType
        subdivisionRate
      }
      invoices {
        dateCreated
        dateUpdated
        createdBy
        updatedBy
        discount {
          appliedBy
          appliedDate
          isPercent
          code
          amount
        }
        invoiceRef
        status
        locked
        invoiceType
        startDate
        endDate
        tax {
          appliedBy
          appliedDate
          code
          amount
        }
        invoiceItems {
          type
          description
          quantity
          unitPrice
          totalAmount
        }
        totalPayableAmount
        anyPaidAmount
        confirmedPaidAmount
        anyRefundAmount
        confirmedRefundAmount
        otherRefunds
        depositRefund
        balanceDueFromPreviousInvoice
        damageAmount
        finesAmount
        valetAmount
        otherCharges {
          amount
          name
        }
        id
        taxAmount
        rentalAmount
        insuranceAmount
        discountAmount
        addonsAmount
        rateTypeName
        rateTypeDuration
      }
      activeInvoices {
        id
        dateCreated
        invoiceRef
        status
        startDate
        endDate
        invoiceType
        totalPayableAmount
        confirmedPaidAmount
        otherCharges {
          amount
          name
        }
      }
      rateTypeName
      rateTypeDuration
      billingCycleName
      billingCycleDuration
      status
      addonRequirements {
        addon {
          id
          name
          category
          imageUrl
          hasFixedRate
          hasQuantity
          fixedRate
          description
          displayName
          recurringRate {
            rateTypeName
            rateTypeDuration
            rate
            longTerm
          }
          totalQuantity
          availableQuantity
          isActivated
        }
        rate
        quantity
        name
        hasFixedRate
        displayName
        payableAmount
        tax {
          title
          value
        }
        isSubscriptionIncluded
      }
      customer {
        id
        firstName
        lastName
        email
        phoneNumber {
          phone
          country
        }
        dateOfBirth
        customerPCONumber
        location {
          street
          city
          state
          country
          zipcode
          fullAddress
        }
        license {
          dateOfExpiry
          licenseNumber
          authority
        }
      }
      currentBookingSchedules {
        id
        startDate
        endDate
        status
        vehicleStatus
        vehicle {
          id
          licencePlate
          imageUrl
          pcoNumber
          vin
          make
          model
          features
          activeVehicleDamages {
            id
            damages {
              title
              damageType
              damageKind
              damageArea
              descriptions
              location {
                x
                y
              }
            }
          }
          vehicleState {
            type
            odometerReading
            generalChecks {
              name
              status
              images
            }
            defaultAccesories {
              name
              status
              images
            }
          }
        }
        dropoffCheck {
          customerInfo {
            signature
          }
          vehicleStatePdfUrl
        }
      }
      businessCustomer {
        id
        businessName
        registrationNumber
        VAT
        registeredAddress {
          street
          city
          state
          zipcode
          country
          fullAddress
        }
        tradingAddressSame
        tradingAddress {
          street
          city
          state
          zipcode
          country
          fullAddress
        }
        approvedDrivers {
          id
          status
          firstName
          lastName
          phoneNumber {
            phone
            country
          }
          email
        }
        authorizedSignatories {
          id
          firstName
          lastName
          phoneNumber {
            phone
            country
          }
          email
        }
        billing {
          phoneNumber {
            phone
            country
          }
          email
        }
        contact {
          firstName
          lastName
          phoneNumber {
            phone
            country
          }
          email
        }
        documents {
          id
          name
          title
          documentType
          expiryDate
          url
        }
      }
      authorizedSignatory
      insurancePolicy {
        id
        name
        description
      }
      paymentDetails {
        rentalAmount
        startDate
        endDate
        taxAmount
        rentalAmount
        insuranceAmount
        discountAmount
        addonsAmount
        totalPayableAmount
        rentalTime
        isProrated
        standardBillingDays
        proratedBillingDays
      }
      vehicleGroups {
        activeVehicleSchedules {
          id
          vehicleStatus
          vehicle {
            id
            licencePlate
            make
            model
            features
            colour
            pcoNumber
            vin
          }
          dropoffCheck {
            vehicleStatePdfUrl
          }
          pickupCheck {
            vehicleStatePdfUrl
          }
        }
        vehicleGroup {
          name
          id
        }
        vehicleIds
        baseRate
        priceRuleOperator
        priceRuleValueType
        priceRuleTriggerType
        priceRuleAmount
        priceRuleName
        deposit
        mileageLimit
        pricePerExtraMile
        count
      }
      approvedDrivers {
        id
        status
        firstName
        lastName
        phoneNumber {
          phone
          country
        }
        email
        location {
          street
          state
          country
          fullAddress
        }
        license {
          authority
          licenseNumber
          dateOfExpiry
          images
        }
      }
      notes {
        id
        description
        createdBy {
          id
          firstName
          lastName
        }
        createdDate
      }
      additionalInformation {
        description
      }
      locationSurcharges {
        id
        name
        value
        rate
        type
        tax {
          title
          value
        }
        payableAmount
        payableTaxAmount
      }
      oneWayRentalFee {
        amount
        taxable
        tax {
          title
          type
          value
        }
      }
      noteFromWebsite {
        description
        createdAt
      }
    }
  }
`;
